import chevronDownIcon from '@jetbrains/icons/chevron-down'
import chevronRightIcon from '@jetbrains/icons/chevron-right'
import Button from '@jetbrains/ring-ui/components/button/button'
import React from 'react'

import styles from './ShowAllOptions.css'

import {DisabledContext} from 'src/components/pages/PipelinesPages/contexts/DisabledContext'
import useBooleanState from 'src/components/pages/PipelinesPages/hooks/useBooleanState'

type Props = {
  defaultCollapsed?: boolean
  children?: React.ReactNode
}

function ShowAllOptions({children, defaultCollapsed = true}: Props) {
  const isDisabled = React.useContext(DisabledContext)
  const [isCollapsed, collapse, expand] = useBooleanState(defaultCollapsed)

  return (
    <div className={styles.showAllContainer}>
      <Button
        className={styles.toggle}
        icon={isCollapsed ? chevronRightIcon : chevronDownIcon}
        onClick={isCollapsed ? expand : collapse}
        disabled={isDisabled}
        aria-expanded={isCollapsed ? 'false' : 'true'}
        aria-controls={'all-options'}
        text
      >{`${isCollapsed ? 'Show' : 'Hide'} all options`}</Button>
      {!isCollapsed && (
        <div id={'all-options'} className={styles.options}>
          {children}
        </div>
      )}
    </div>
  )
}

export default ShowAllOptions
